import React, { useMemo } from 'react';
import { ScrollText } from 'lucide-react';
import SchemaModal from '../../../ui/SchemaModal';
import BottomSheet from '../../../ui/BottomSheet';
import EmptyState from '../../../ui/EmptyState';
import { useIsMobileViewport } from '../../../ui/breakpoints';
import './ProtocolSheet.css';

export const PROTOCOL_MAX_ENTRIES = 200;

const toDate = (timestamp) => {
  const date = new Date(timestamp);
  return Number.isNaN(date.getTime()) ? null : date;
};

/**
 * Protokoll des Playtests: die letzten 200 Einträge, neueste oben, jeweils mit Uhrzeit.
 *
 *   <ProtocolSheet open={open} onOpenChange={setOpen} entries={state.sessionLog} />
 *
 * - `entries` sind `{ message, timestamp }` in zeitlicher Reihenfolge (älteste zuerst), wie
 *   `state.sessionLog` sie hält.
 * - Rechner: `SchemaModal size="md"`; Handy (`useIsMobileViewport`): `BottomSheet`. Beide hängen
 *   selbst an der Zurück-Geste.
 */
export default function ProtocolSheet({ open, onOpenChange, entries = [] }) {
  const isMobile = useIsMobileViewport();
  const latest = useMemo(() => entries.slice(-PROTOCOL_MAX_ENTRIES).reverse(), [entries]);

  const body = latest.length === 0 ? (
    <EmptyState icon={ScrollText} title="Noch keine Einträge" />
  ) : (
    <ol className="protocol-sheet" aria-label="Protokolleinträge">
      {latest.map((entry, i) => {
        const date = toDate(entry.timestamp);
        return (
          <li key={`${entry.timestamp}-${i}`} className="protocol-sheet__entry">
            <time className="protocol-sheet__time" dateTime={date?.toISOString()}>
              {date ? date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) : ''}
            </time>
            <span className="protocol-sheet__message">{entry.message}</span>
          </li>
        );
      })}
    </ol>
  );

  if (isMobile) {
    return (
      <BottomSheet open={open} onOpenChange={onOpenChange} title="Protokoll" size="tall">
        {body}
      </BottomSheet>
    );
  }
  return (
    <SchemaModal open={open} onOpenChange={onOpenChange} size="md" title="Protokoll">
      {body}
    </SchemaModal>
  );
}
